import { useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Typography } from "@mui/material";
import Sidebar from "../Sidebar";
import Header from "../Header";
import StudentTabs from "../StudentTabs";
import EmptyContent from "../EmptyContent";
import { useStudents } from "../../context/students";
import { useTranslate } from "../../hooks/useTranslate";
import ErrorBoundary from "../ErrorBoundary";
import { StudentRedirectHandler } from "../../router/StudentRedirectHandler";
import { STUDENT_STATUS } from "../../constants/student.status";
import "./Layout.css";

const Layout = ({ withStudents, children }) => {
    const { students } = useStudents();
    const { t } = useTranslate();
    const { pathname } = useLocation();

    const studentsToShow = useMemo(() => (students || []).filter((student) => Object.values(STUDENT_STATUS).includes(student?.studentStatusCode)), [students]);

    const isAlumni = pathname.endsWith("alumni");
    const isAddStudent = pathname.endsWith("add-student/new");
    const showAddStudentOnly = isAlumni || isAddStudent;

    return (
        <div className="Layout">
            <Sidebar />
            <main className="Layout-main">
                <Header>
                    {(withStudents || showAddStudentOnly) && (
                        <StudentTabs showAddStudentOnly={showAddStudentOnly} />
                    )}
                </Header>
                <ErrorBoundary>
                    <EmptyContent
                        data={withStudents ? studentsToShow : {}}
                        text={(
                            <div className="students-empty">
                                <Typography
                                    variant="h6"
                                    component="h2"
                                    className="students-empty__title"
                                >
                                    {t("noStudentsText.title")}
                                </Typography>

                                <Typography
                                    variant="body1"
                                    className="students-empty__description"
                                >
                                    {t("noStudentsText.description")}
                                </Typography>
                            </div>
                        )}
                    >
                        {withStudents ? (
                            <StudentRedirectHandler>
                                {children || <Outlet />}
                            </StudentRedirectHandler>
                        ) : (
                            children || <Outlet />
                        )}
                        {/* <StudentContractBlockModal /> */}
                    </EmptyContent>
                </ErrorBoundary>
            </main>
        </div>
    );
};

export default Layout;
